import { render, staticRenderFns } from "./MatchMakingTimer.vue?vue&type=template&id=1530a8c4&scoped=true"
import script from "./MatchMakingTimer.vue?vue&type=script&lang=js"
export * from "./MatchMakingTimer.vue?vue&type=script&lang=js"
import style0 from "./MatchMakingTimer.vue?vue&type=style&index=0&id=1530a8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530a8c4",
  null
  
)

export default component.exports